export default "__VITE_PUBLIC_ASSET__2e97ba9f__"